.page {
  background: var(--bg);
  min-height: calc(100vh - 68px);
}

.topbar {
  background: white;
  border-bottom: 1px solid var(--border);
  padding: 0 32px;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 56px;
  position: sticky;
  top: 68px;
  z-index: 50;
  box-shadow: 0 1px 3px rgba(60,64,67,.08);
}

.topbarActions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.topbarError {
  font-size: 13px;
  color: var(--red);
  display: flex;
  align-items: center;
  gap: 5px;
  margin-right: 4px;
}

.discardBtn {
  display: inline-flex;
  align-items: center;
  padding: 7px 18px;
  background: white;
  color: var(--muted);
  border: 1.5px solid var(--border);
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 500;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  transition: border-color .15s, color .15s, background .15s;
}

.discardBtn:hover {
  border-color: #bdc1c6;
  color: var(--ink);
  background: var(--bg);
}

.silentToggle {
  display: flex;
  border: 1.5px solid var(--border);
  border-radius: 20px;
  overflow: hidden;
}

.silentBtn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Google Sans', sans-serif;
  color: var(--muted);
  cursor: pointer;
  transition: background .15s, color .15s;
}

.silentBtn:hover { background: var(--bg); color: var(--ink); }

.silentBtnActive {
  background: var(--ink);
  color: white;
}

.silentBtnActive:hover { background: var(--ink2); color: white; }

.saveBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 18px;
  background: var(--blue);
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 600;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(26,115,232,.3);
  transition: background .15s, box-shadow .15s, transform .1s;
}

.saveBtn:hover {
  background: var(--blue-dk);
  box-shadow: 0 2px 6px rgba(26,115,232,.4);
  transform: translateY(-1px);
}

.saveBtn:active { transform: translateY(0); }
.saveBtn:disabled, .discardBtn:disabled { opacity: .5; cursor: default; }

.backBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--blue);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background: none;
  border: none;
  padding: 7px 10px;
  border-radius: 4px;
  transition: background .15s;
  font-family: 'Roboto', sans-serif;
}

.backBtn:hover { background: var(--blue-lt); }

.topbarDivider {
  width: 1px;
  height: 20px;
  background: var(--border);
}

.topbarName {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  font-family: 'Google Sans', sans-serif;
}

.body {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 100px;
  width: 100%;
}

.card {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  min-height: 520px;
}

.tabs {
  display: flex;
  border-bottom: 1px solid var(--border);
  padding: 8px 12px;
  gap: 4px;
}

.tab {
  padding: 7px 13px;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--muted);
  cursor: pointer;
  border: none;
  border-radius: 20px;
  background: none;
  display: flex;
  align-items: center;
  gap: 5px;
  letter-spacing: .01em;
  white-space: nowrap;
  transition: background .15s, color .15s;
  font-family: 'Roboto', sans-serif;
}

.tab:hover { background: var(--bg); color: var(--ink); }
.tabActive { background: var(--blue-lt); color: var(--blue); font-weight: 600; }

.loadingState {
  text-align: center;
  padding: 80px;
  color: var(--muted);
}

.rejectedBanner {
  max-width: 1200px;
  margin: 12px auto 0;
  padding: 0 32px;
  display: flex;
  gap: 10px;
  background: var(--yellow-lt);
  border: 1px solid #f0d080;
  border-radius: var(--radius);
  padding: 12px 16px;
  font-size: 13.5px;
}

.rejectedItem {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.rejectedItem:last-child { margin-bottom: 0; }

.rejectedKind {
  font-size: 11.5px;
  background: white;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 2px 7px;
  color: var(--muted);
}

.rejectedReason { color: var(--ink2); }

.retryBtn {
  background: none;
  border: none;
  color: var(--blue);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}
.retryBtn:hover { color: var(--blue-dk); }
